import * as React from 'react';
import { onActiveGroupsChange } from '../analytics/coanalyt/core/onetrust-active-groups';
import Coanalyt from '../analytics/coanalyt';

const AnalyticsProvider = ({ children }: React.PropsWithChildren) => {
  React.useEffect(() => {
    onActiveGroupsChange(() => {
      try {
        // Reset the singleton so the next getInstance() builds a fresh AnalyticsConnector
        // with the privacyConsent function evaluated after window.OnetrustActiveGroups is set.
        Coanalyt.reset();
        Coanalyt.getInstance().init();
      } catch (error) {
        console.error('[AnalyticsProvider] Failed to initialize Coanalyt:', error);
      }
    });
  }, []);

  return <>{children}</>;
};

export { AnalyticsProvider };
